import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MachineMapping } from 'src/app/models/usermanagement/MachineMapping';
import { MatDialog } from '@angular/material/dialog';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { ButtonDeleteRendererComponent } from 'src/app/components/button-delete-render.components';
import * as moment from 'moment';
import { Console } from 'console';

interface Group {
 value: string;
 viewValue: string;
}
@Component({
      selector: 'app-machinemapping',
        templateUrl: './machinemapping.component.html',
        styleUrls: ['./machinemapping.component.scss']
      })
export class MachinemappingComponent implements OnInit {

//  @ViewChild(MatTable) table: MatTable<MachineMapping> | undefined;
//  @ViewChild(MatPaginator) paginator!: MatPaginator;
//  @ViewChild(MatSort) sort!: MatSort;
 @ViewChild('displayRoleModal') private displayRoleModal!: TemplateRef<any>;

 rowData!: any[];
 columnDefs!: any[];
 gridApi: any;
 gridColumnApi: any;
 frameworkComponents: any;
 isDisable = true;
 languageDir = 'ltr';
 langObj: any = {};
 lang: any;
 moduleId!: any;
 pageId!:any;
 gridOptions: any = {
  defaultColDef: {
     rowModelType: 'infinite',
     infiniteInitialRowCount: 2,
     flex: 1,
     sortable: true,
     resizable: true,
     wrapText: true, // <-- HERE
     autoHeight: true, // <-- & HERE
     minWidth: 225,
   },
   medalColumn: {
     width: 100,
     columnGroupShow: 'open',
     filter: false,
   },
   popupParent: document.querySelector('body'),
   floatingFilter: true,
 };
 public excelStyles!: any;

 GroupList!: any[];
 UsersList!: any[];
 PlantList!: any[];
 ProductList!: any[];
 UnitsList!: any[];
 machineId!: number;
 UserId!: number;
//  machineData!: MatTableDataSource<MachineMapping>;
 userRoleForm!: FormGroup;
 plantDataForm!: FormGroup;
 machineForm = true;
 status: Group[] = [
   { value: 'None', viewValue: 'None' },
 ];
 MachineMapData: MachineMapping[] = [];
//  MachineMappingColumns: string[] = ['MachineRoleId', 'ProductUnit', 'CreatedOn', 'CreatedBy', 'Actions'];
//  machineMappingData = new MatTableDataSource<MachineMapping>();
  GroupId!: number;
  breadcrumList: any;
  IsWrite: any;
  IsAccess: any;
  filteredGroups: any;
  filteredUsers: any;
 // tslint:disable-next-line: no-shadowed-variable
 constructor(private formBuilder: FormBuilder,
             private dialog: MatDialog,
             private userService: UserManagementService,
             private machineService: MachineMappingService,
             private spinner: NgxSpinnerService,
             private kpiMaster: KpimasterService,
              public router: Router,
             private toaster: ToastrService, 
             private translate: TranslateService,
             private translater: TranslaterService
          ) {
            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
              if (event.lang === 'ar') {
                this.languageDir = 'rtl';
                this.getLangWords();
              }else if(event.lang === 'en'){
                this.languageDir = 'ltr';
                this.getLangWords();
              }else if(event.lang === 'fr') {
                this.languageDir = 'ltr';
                this.getLangWords();
              }else if(event.lang === 'sp') {
                this.languageDir = 'ltr';
                this.getLangWords();
              }
            })
            this.frameworkComponents = {
              buttonRendererDelete: ButtonDeleteRendererComponent,
            };
        
           }
 ngOnInit(): void {
  this.datasource();
  this.userRoleForm =  this.formBuilder.group({
     userGroup: [''],
     UserName: [''],
     plant : [''],
     product : ['']
   });
  this.plantDataForm =  this.formBuilder.group({
    plant : [''],
    productLine : [''],
    productUnit : ['']
  });
  // this.userRoleForm.get('userGroup')?.setValue(this.GroupList[0].TypeId);

  this.GetBreadcrumList();
  this.GetMenuAccess();
 }

  
  //breadCrumb

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
      this.columnDefs = [
        {
          headerName: 'Actions',
          field: 'Actions',
          // resizable: true,
          // filter: 'agTextColumnFilter',
          cellRenderer: 'buttonRendererDelete',
          cellRendererParams: {
            //clicked(field: any) {},
            onClick: this.DeleteMachine.bind(this),
            label: 'delete',
          },
          maxWidth: 85,
          minWidth: 50,
          cellStyle: { textAlign: 'center', padding: 0 },
          // hide: !this.IsWrite,
          suppressMenu: true,
        },
        {
          headerName: 'MachineRole Id',
          field: 'MachineRoleId',
          filter: 'agTextColumnFilter',
          hide: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Production Unit',
          field: 'ProductionUnit',
          filter: 'agTextColumnFilter',
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Assigned By',
          field: 'AssignedBy',
          filter: 'agTextColumnFilter',
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Assigned Date',
          field: 'AssignedDate',
          filter: 'agTextColumnFilter',
          valueFormatter: function (params: any) { return moment(params.value).format('MM/DD/YYYY HH:mm:ss')},
          headerValueGetter: this.localizeHeader.bind(this)
        },
      ];
      this.excelStyles = [
        {
          id: 'header',
          interior: {
            color: '#a47ed9',
            pattern: 'Solid',
          },
        },
        {
          id: 'body',
          interior: {
            color: '#d1c1e8',
            pattern: 'Solid',
          },
        },
      ];
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  GetBreadcrumList(): any{
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.userService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length -1].id;
      this.getLangWords();
      this.lang = new Multilingual(this.translater,this.translate);
      this.lang.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([url]));
    // return false;
  }

 datasource(): void {
  const key = {
    Id : 0
  };
  // tslint:disable-next-line: no-debugger
  this.userService.getGroupData(key).subscribe( (data: any) => {
  this.GroupList = data.masterList;
  this.userRoleForm.get('userGroup')?.setValue(data.masterList[0].TypeId);
  this.GroupId = this.GroupList[0].TypeId;
  this.filteredGroups = this.GroupList.slice();
  this.getUserslist();
}, (error: any) => {
  this.toaster.error('error', error.message);
});
}

getUserslist(): void {
  const key = {
    GroupId : this.userRoleForm.value.userGroup 
  };
  this.spinner.show();
  // this.machineData = new MatTableDataSource<MachineMapping>();
  this.userService.getUsersData(key).subscribe((data: any) => {
    this.UsersList = data.UserList;
  this.spinner.hide();

    this.userRoleForm.get('UserName')?.setValue(data.UserList[0].UserId);
    this.UserId = this.UsersList[0].UserId;
    this.filteredUsers = this.UsersList.slice();
    this.getMachineData();
   
    // this.userRoleForm.get('UserName')?.setValue(this.GroupList[0].TypeId);
  }, (error: any) => {
  this.spinner.hide();

    this.toaster.error('error', error.error.message);
  });
}

getMachineData(): void {
  const key = {
  UserId :  this.userRoleForm.value.UserName
};
  // tslint:disable-next-line: align
  this.spinner.show();

  this.machineService.getMachineMappingData(key).subscribe((data: any) => {
    if(data.MachineMaplist){
    // this.machineData = new MatTableDataSource<MachineMapping>(data.MachineMaplist);
    this.rowData = data.MachineMaplist;
  this.spinner.hide();
    // this.getPaginator();
    }
  }, (error: any) => {
  this.spinner.hide();

    this.toaster.error('Error', error.message);
  });
  }
// applyFilter(event: Event): void {
//   const filterValue = (event.target as HTMLInputElement).value;
//   this.machineData.filter = filterValue.trim().toLowerCase();

//   if (this.machineData.paginator) {
//     this.machineData.paginator.firstPage();
//   }
// }
 openUnit(): void {
 }

 getproducts(event: any): void {
   const data = {
     Dept_Id : event.value
   };

   this.machineService.getProductData(data).subscribe(( response: any) => {
    // tslint:disable-next-line: align
    this.ProductList = response.LineList;
   }, (error: any) => {
     this.toaster.error('Error', error.message);
   });
 }
 getUnits(event: any): void {
   const key = {
    PL_Id : event.value,
    UserId : this.userRoleForm.value.UserName
   };

   this.machineService.getUnitData(key).subscribe(( response: any) => {

    // tslint:disable-next-line: align
    this.UnitsList = response.UnitList;
   }, (error: any) => {
     this.toaster.error('Error', error.message);
   });
 }

 public localizeHeader(parameters: any) {
  let headerIdentifier = parameters.colDef.field;
  return this.getTransalatedValue(headerIdentifier);
}

getTransalatedValue(value:string){
  let val;
  if(this.langObj && this.langObj[value]){
    val = this.langObj[value];
  }
  return val?val:value;
}

public getLangWords() {
  const key = {
    ModuleId: this.moduleId,
    PageId: this.pageId,
    LanguageId:this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
  };
  this.translater.getLangWords(key).subscribe((res: any) => {
    let obj: any = {};
    res.tagList.map((elem: any) => {
      obj[elem.tagName] = elem.translatedValue;
    });
    this.langObj = obj;
    if(this.langObj){
      this.gridApi.refreshHeader();
    }
  });
}

 onSubmit(event: any): void {
   const key = {
     plid :  this.plantDataForm.value.productLine,
     Puid : this.plantDataForm.value.productUnit,
     Deptid : this.plantDataForm.value.plant,
     TransactionTypeId : 1,
     UserMachineMappId : 0,
     UserId : this.userRoleForm.value.UserName,
     CreatedBy : 0
   };
   this.machineService.AddMachineData(key).subscribe((data: any) => {
    this.showPopupMsg(data.ErrorMessage);
    this.dialog.closeAll();
  // tslint:disable-next-line: align
  // this.toaster.success('Machine added successfuly');
     // tslint:disable-next-line: align
     this.getMachineData();
}, (error: any) => {
  this.showPopupMsg(error.ErrorMessage);
  // this.toaster.error('Error', error.message);
});
 }
 highlight(row: any): void {
 this.machineId = row.MachineMapId;

 }
 Update(event: any): void {
  const key = {
    plid :  this.plantDataForm.value.productLine,
    Puid : this.plantDataForm.value.productUnit,
    Deptid : this.plantDataForm.value.plant,
    TransactionTypeId1 : 2,
    UserMachineMappId : 1,
    UserId : this.userRoleForm.value.UserName
  };
//   this.machineService.AddMachineData(key).subscribe((data: any) => {
//  this.toaster.success('Machine updated successfuly');
//  this.datasource();
// }, (error: any) => {
//  this.toaster.error('Error', error.message);
// });
}

DeleteMachine($event): void {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to delete Machine!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then( (Result: any) => {
    if (Result.dismiss === Swal.DismissReason.cancel){
      Swal.fire('Cancelled', 'Your Machine is safe :)', 'error');
}
else if (Result){
  const key = {
    TransactionTypeId : 3,
    UserMachineMappId : $event.data.MachineMapId,
    UserId : this.userRoleForm.value.UserName
  };
  this.machineService.AddMachineData(key).subscribe((data: any) => {
    this.showPopupMsg(data.ErrorMessage);
    Swal.fire({
      title: 'Deleted!',
      text: 'Your selected Machine has been deleted.',
      icon: 'success',
      timer: 800,
      showConfirmButton: false,
    });
    this.getMachineData();
   }, (error: any) => {
     this.showPopupMsg(error.ErrorMessage);
    // this.toaster.error('Error', error.message);
   });
 }
});
}
// getPaginator(): void {
//   setTimeout(() => {
//     this.machineData.paginator = this.paginator;
//     this.machineData.sort = this.sort;
//   }, 1000);
// }
 openModal(): void {
   const key = {
     GroupId : this.userRoleForm.value.userGroup
   };
   this.dialog.open(this.displayRoleModal, {height: 'auto', width: 'auto'});

   this.machineService.getPlantsData(key).subscribe((data: any) => {
    this.PlantList = data.DepartList;
   }, (error: any) => {
     this.toaster.error('Error', error.message);
   });
 }

 showPopupMsg(msg: any): any {
  if (msg.substring(2, 1) === '0') {
     this.toaster.success('Success', msg.substring(3, msg.length));
  }
  else {
    this.toaster.error('Error', msg.substring(3, msg.length));
  }
}

onGridReady(params: any): any {
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
}

excelExport() {
  let params: any = {
    columnKeys: ['MachineRoleId', 'ProductionUnit', 'AssignedBy', 'AssignedDate'],
    skipHeader: false,
    //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
  };
  params.processCellCallback = function (cellParams: any) {
    if (cellParams && cellParams.column.colId === 'AssignedDate')
      return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
    else
      return cellParams.value // no formatting
  }
  this.gridApi.exportDataAsExcel(params);
}

csvExport() {
  let params: any = {
    columnKeys: ['MachineRoleId', 'ProductionUnit', 'AssignedBy', 'AssignedDate'],
    allColumns: false,
    skipHeader: false,
    //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
  };
  params.processCellCallback = function (cellParams: any) {
    if (cellParams && cellParams.column.colId === 'AssignedDate')
      return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
    else
      return cellParams.value // no formatting
  }
  this.gridApi.exportDataAsCsv(params);
}

}



